module.exports = __webpack_public_path__ + "static/progetto_valtellinapalace5-e1c4e8a6d4cf8b7dda6151c62fbc8cca.jpg";